export const GroupTUThingTypeMrn = "mrn:sl2:iam::groupTU";
